var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3AutoBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 38a27 27 0 01-51.88 10.51A26.78 26.78 0 0111 38H4.21l9.23-10 9.23 10H15a23 23 0 0014 21.19 23.15 23.15 0 0017.9 0A23 23 0 0059.19 29 23.1 23.1 0 0047 16.81a23.151 23.151 0 00-17.9 0 22.78 22.78 0 00-7.31 4.93l-2.83-2.83A27 27 0 0165 38zm-33.5 6L29 51h-4.89l11-28h6L51.9 51h-5l-2.45-7H31.5zm2-4h9L38 28.29 33.5 40z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_Auto_bis.2e10b37a.svg";
export { SvgJ3AutoBis as ReactComponent };